import React from 'react';
import { Card, CardContent } from '@ncoder/ui';
import { LucideIcon } from 'lucide-react';

interface MetricCardProps {
  title: string;
  value: string | number;
  icon: LucideIcon;
  iconColor?: string;
  valueColor?: string;
}

export const MetricCard: React.FC<MetricCardProps> = ({
  title,
  value,
  icon: Icon,
  iconColor = 'text-muted-foreground',
  valueColor = '',
}) => {
  return (
    <Card className="relative">
      <CardContent className="p-4">
        <div className="flex flex-col gap-2">
          <div className="flex items-center justify-between">
            <p className="text-xs font-medium text-muted-foreground truncate">{title}</p>
            <Icon className={`h-4 w-4 ${iconColor}`} />
          </div>
          <p className={`text-xl font-bold ${valueColor}`}>{value}</p>
        </div>
      </CardContent>
    </Card>
  );
};
